import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './ProfileMenu.css';

export default function ProfileMenu({ email, onLogout, onNavigate }) {
  const [open, setOpen] = useState(false);
  const [avatar, setAvatar] = useState('');
  const root = useRef(null);
  const trigger = useRef(null);

  useEffect(() => {
    let active = true;
    setAvatar('');
    const normalized = (email || '').trim().toLowerCase();
    if (normalized && window.crypto && window.crypto.subtle && window.TextEncoder) {
      window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(normalized)).then(buffer => {
        const hash = Array.from(new Uint8Array(buffer), b => b.toString(16).padStart(2, '0')).join('');
        if (active) setAvatar(`https://www.gravatar.com/avatar/${hash}?s=80&d=mp&r=g`);
      }).catch(() => {});
    }
    return () => { active = false; };
  }, [email]);

  useEffect(() => {
    if (!open) return;
    function outside(event) {
      if (root.current && !root.current.contains(event.target)) setOpen(false);
    }
    document.addEventListener('mousedown', outside);
    document.addEventListener('touchstart', outside);
    return () => {
      document.removeEventListener('mousedown', outside);
      document.removeEventListener('touchstart', outside);
    };
  }, [open]);

  function navigate() { setOpen(false); onNavigate(); }
  return <div className="profile-menu" ref={root}
    onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false); }}
    onKeyDown={event => {
      if (event.key === 'Escape') { setOpen(false); trigger.current.focus(); }
    }}>
    <button type="button" className="button is-light header-icon-button profile-menu-trigger" ref={trigger}
      aria-label="Profile" aria-expanded={open} aria-controls="profile-options"
      onClick={() => setOpen(!open)}>
      {avatar ? <img src={avatar} alt="" width="40" height="40" referrerPolicy="no-referrer"
        onError={() => setAvatar('')} /> : <i className="fas fa-user" aria-hidden="true" />}
    </button>
    {open && <div id="profile-options" className="profile-menu-options">
      <Link to="/account/password" className="profile-menu-option" onClick={navigate}>Change password</Link>
      <button type="button" className="profile-menu-option" onClick={event => { setOpen(false); onLogout(event); }}>Log out</button>
    </div>}
  </div>;
}
